import { createContext, useContext } from "react"
import { GenericListContextValue } from "../types"

const GenericListContext = createContext<GenericListContextValue | null>(null)

export const useData = () => {
  const context = useContext(GenericListContext)
  if (!context) {
    throw new Error("useData must be used within a GenericListProvider")
  }
  return context
}

export { GenericListContext }
